const { getElement } = window.BAO.Utils

class PersonalisationTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleClick = this.handleClick.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleExternalButtonClick = this.handleExternalButtonClick.bind(this)
    this.checkVariantSelected = this.checkVariantSelected.bind(this)

    this.els.tab.elements.forEach((tabEl) => {
      this.listeners.add(tabEl, 'click', this.handleClick)
      this.listeners.add(tabEl, 'keydown', this.handleKeyDown)
    })

    this.externalEls['personalisation-button']?.elements.forEach((el) => {
      this.listeners.add(
        el,
        'click',
        this.handleExternalButtonClick.bind(this, 'panel-add-personalisation'),
      )
    })

    this.externalEls['sold-out-link-size']?.elements.forEach((el) => {
      this.listeners.add(
        el,
        'click',
        this.handleExternalButtonClick.bind(this, 'panel-customisation'),
      )
    })

    this.externalEls['status-edit-button']?.elements.forEach((el) => {
      this.listeners.add(
        el,
        'click',
        this.handleExternalButtonClick.bind(this, 'panel-customisation'),
      )
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PDP.VARIANT_CHANGED,
      this.handleVariantChange.bind(this),
    )

    this.externalEls['status-edit-button-size']?.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.handleOpenSizeDrawer.bind(this))
    })
  }

  // Accessibility, allows arrow keys for toggle
  handleKeyDown (event) {
    const currentIndex = this.els.tab.elements.indexOf(event.target)
    let newIndex

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault()
        newIndex = (currentIndex + 1) % this.els.tab.elements.length
        break
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault()
        newIndex =
          (currentIndex - 1 + this.els.tab.elements.length) %
          this.els.tab.elements.length
        break
      case 'Home':
        event.preventDefault()
        newIndex = 0
        break
      case 'End':
        event.preventDefault()
        newIndex = this.els.tab.elements.length - 1
        break
      default:
        return
    }

    const newTab = this.els.tab.elements[newIndex]
    newTab.focus()
    this.handleElementHidingShowing(newTab)
  }

  handleClick (event) {
    const clickedTab = event.currentTarget
    if (!this.checkVariantSelected()) return
    this.handleElementHidingShowing(clickedTab)
    this.handleLoyaltyLion(clickedTab)
    this.handleKlarna(clickedTab)
    this.handleClearpay(clickedTab)
  }

  handleExternalButtonClick (target) {
    if (!this.checkVariantSelected()) return

    const targetTab = this.els.tab.elements.find(
      (tab) => tab.getAttribute('aria-controls') === target,
    )

    if (targetTab) {
      this.handleElementHidingShowing(targetTab)
      this.handleLoyaltyLion(targetTab)
      this.handleKlarna(targetTab)
      this.handleClearpay(targetTab)

      targetTab.focus()
    }
  }

  checkVariantSelected () {
    const productForm = this.externalEls.form?.element

    if (!productForm) return false

    const formSubmit = productForm.querySelector(
      '[data-personalisation-tabs-external-el="personalisation-button"]',
    )

    if (!formSubmit) return false

    const productVariants = this.externalEls.variant?.elements
    const selectedVariant = productVariants?.find(
      (variantEl) => variantEl.checked,
    )

    if (productVariants?.length > 0 && selectedVariant) {
      const personalisationPlacements = this.externalEls.placement?.elements

      personalisationPlacements.forEach((placement) => {
        if (placement.dataset.placementTitle.includes(selectedVariant.value)) {
          placement.setAttribute('aria-hidden', false)
        } else {
          placement.setAttribute('aria-hidden', true)
        }
      })
    }

    if (formSubmit.hasAttribute('data-disabled')) {
      this.externalEls['variant-error']?.element.setAttribute(
        'aria-hidden',
        false,
      )
      return false
    }

    return true
  }

  handleVariantChange (e) {
    const variant = e.detail?.variant?.data

    if (!variant) {
      return
    }

    this.externalEls['variant-error']?.element.setAttribute(
      'aria-hidden',
      true,
    )
  }

  handleElementHidingShowing (clickedTab) {
    this.updateTabStates(clickedTab)

    const panelId = clickedTab.getAttribute('aria-controls')

    this.handleMediaColumn(panelId)
    this.handleMainColumn(panelId)
  }

  updateTabStates (clickedTab) {
    this.els.tab.elements.forEach((tabEl) => {
      tabEl.setAttribute('aria-selected', tabEl === clickedTab)
      tabEl.setAttribute('tabindex', tabEl === clickedTab ? '0' : '-1')
    })
  }

  handleMediaColumn (panelId) {
    const customisationMedia = this.externalEls['customisation-media']?.element
    const personalisationMedia =
      this.externalEls['personalisation-media']?.element

    if (!customisationMedia || !personalisationMedia) return

    customisationMedia.ariaHidden = panelId !== 'panel-customisation'
    personalisationMedia.ariaHidden = panelId === 'panel-customisation'

    window.dispatchEvent(new Event('resize'))
  }

  handleMainColumn (panelId) {
    const form = this.externalEls.form?.element
    const personalisationForm =
      this.externalEls['personalisation-form']?.element
    if (!form || !personalisationForm) return

    form.ariaHidden = panelId === 'panel-add-personalisation'
    personalisationForm.ariaHidden = panelId !== 'panel-add-personalisation'
  }

  handleLoyaltyLion (clickedTab) {
    const loyaltyElement = getElement('[data-product-loyalty]')
    const loyaltyElementPriceToUpdate = getElement(
      '[data-lion-price-for-product-id]',
      {
        context: loyaltyElement,
      },
    )
    const loyaltyElementPointsToUpdate = getElement(
      '[data-lion-points-for-product-id]',
      {
        context: loyaltyElement,
      },
    )

    let idToUse = clickedTab.dataset.loyaltyProductId
    let priceToUse = clickedTab.dataset.loyaltyPriceStyled

    if (
      clickedTab.getAttribute('aria-controls') === 'panel-add-personalisation'
    ) {
      const activeEngravingTab = getElement(
        '[data-personalisation-types-el="engravingButton"][aria-checked="true"]',
      )

      if (activeEngravingTab?.dataset.personalisationPrice) {
        idToUse = activeEngravingTab.dataset.personalisationProductId
      }

      if (activeEngravingTab?.dataset.personalisationPriceStyled) {
        priceToUse = activeEngravingTab.dataset.personalisationPriceStyled
      }
    }

    if (loyaltyElementPriceToUpdate) {
      loyaltyElementPriceToUpdate.dataset.lionPriceForProductId = idToUse
      loyaltyElementPriceToUpdate.innerText = priceToUse
    }

    if (loyaltyElementPointsToUpdate) {
      loyaltyElementPointsToUpdate.dataset.lionPointsForProductId = idToUse
    }

    if (window.loyaltylion) {
      window.loyaltylion?.ui?.refresh()
    }
  }

  handleKlarna (clickedTab) {
    const klarnaElement = getElement('klarna-placement')
    if (!klarnaElement) return

    let priceToUse = clickedTab.dataset.personalisationPrice

    if (
      clickedTab.getAttribute('aria-controls') === 'panel-add-personalisation'
    ) {
      const activeEngravingTab = getElement(
        '[data-personalisation-types-el="engravingButton"][aria-checked="true"]',
      )

      if (activeEngravingTab?.dataset.personalisationPrice) {
        priceToUse = activeEngravingTab.dataset.personalisationPrice
      }
    }

    // Line below is required to trigger Klarna's refresh because window.Klarna.OnsiteMessaging refresh doesn't seem to actually refresh.
    klarnaElement.dataset.purchaseAmount = priceToUse

    if (window.Klarna?.OnsiteMessaging) {
      window.Klarna?.OnsiteMessaging.on('placementRendered', () => {
        klarnaElement.dataset.purchaseAmount = parseInt(priceToUse)
      })
    }
  }

  handleClearpay (clickedTab) {
    const clearpayElement = getElement('square-placement')
    if (!clearpayElement) return

    let priceToUse = clickedTab.dataset.personalisationPrice

    if (
      clickedTab.getAttribute('aria-controls') === 'panel-add-personalisation'
    ) {
      const activeEngravingTab = getElement(
        '[data-personalisation-types-el="engravingButton"][aria-checked="true"]',
      )

      if (activeEngravingTab?.dataset.personalisationPrice) {
        priceToUse = activeEngravingTab.dataset.personalisationPrice
      }
    }

    clearpayElement.setAttribute('data-amount', (priceToUse / 100).toFixed(2))
    clearpayElement.refresh?.()
  }

  handleOpenSizeDrawer () {
    const sizeDrawerButton = getElement(
      '[data-personalisation-tabs-external-el="size-drawer-button"]',
    )

    if (sizeDrawerButton) {
      sizeDrawerButton.click()
    }
  }
}

if (!customElements.get('personalisation-tabs')) {
  customElements.define('personalisation-tabs', PersonalisationTabs)
}
